/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import React from "react";
import Head from "next/head";
import Header from "../../../common/header/Header";
import Footer from "../../../common/footer/Footer";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      a: "a",
      h2: "h2",
      ol: "ol",
      li: "li",
      h3: "h3",
      ul: "ul",
      strong: "strong",
      em: "em"
    }, props.components);
    return _jsxs("main", {
      className: "page-wrapper",
      children: [_jsx(Head, {
        children: _jsx("title", {
          children: "Modulabs | Privacy Regulations Reference"
        })
      }), _jsx(Header, {
        className: "header-not-transparent"
      }), _jsx("div", {
        className: "post-page-banner rn-section-gapTop",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content text-center",
                children: _jsx("div", {
                  className: "page-title",
                  children: _jsx("h1", {
                    className: "theme-gradient",
                    children: "Privacy Regulations Reference"
                  })
                })
              })
            })
          })
        })
      }), _jsx("div", {
        className: "blog-details-content pt--60 rn-section-gapBottom",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content",
                children: _jsxs("div", {
                  children: [_jsxs(_components.p, {
                    children: ["The data privacy regulatory landscape is undergoing a lot of change. You probably have heard\nabout the EU General Data Protection Regulation (GDPR) that went into effect on May 25,\n2018. There are also other regulations in effect or in the works around the world. We’ve\nwritten up this reference document to put helpful information regarding our products and\nprivacy regulations in one place. Please also view our full ", _jsx(_components.a, {
                      href: "./",
                      children: "Privacy policy"
                    }), "."]
                  }), _jsxs(_components.p, {
                    children: ["If you have any questions, comments, or concerns about our ", _jsx(_components.a, {
                      href: "./",
                      children: "Privacy policy"
                    }), ",\nyour data, or your rights with respect to your information, please email us at\n", _jsx(_components.a, {
                      href: "mailto:privacy@modulabs.io",
                      children: "privacy@modulabs.io"
                    }), "."]
                  }), _jsx(_components.h2, {
                    children: "European Union General Data Protection Regulation (GDPR)"
                  }), _jsx(_components.p, {
                    children: "Modulabs is an American company and our data infrastructure is currently based in the US.\nThat means if you are in another country in the world and you use our products, your data\nare transferred to the US. The EU has stronger privacy laws than the US and a core tenet of\nthe GDPR is that if you transfer any personal data of EU residents out of the EU, you must\nprotect it to the same level as guaranteed under EU law. There are two factors to this:"
                  }), _jsxs(_components.ol, {
                    children: ["\n", _jsx(_components.li, {
                      children: "The practices that businesses take handling personal data; and"
                    }), "\n", _jsx(_components.li, {
                      children: "The laws of the countries where you transfer the EU personal data to"
                    }), "\n"]
                  }), _jsx(_components.h3, {
                    children: "Practices we have at Modulabs"
                  }), _jsx(_components.p, {
                    children: "We are serious about treating our customers fairly, and the security measures we put in\nplace to protect your data. These rights apply to all of our customers, regardless of where\nyou are in the world."
                  }), _jsxs(_components.p, {
                    children: ["Please do read our ", _jsx(_components.a, {
                      href: "./",
                      children: "Privacy Policy"
                    }), " and our ", _jsx(_components.a, {
                      href: "../security",
                      children: "Security\nOverview"
                    }), " in full. Some highlights:"]
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsx(_components.li, {
                      children: "We never have and never will sell customer data."
                    }), "\n", _jsx(_components.li, {
                      children: "We don’t run ads for other services in our products."
                    }), "\n", _jsx(_components.li, {
                      children: "We limit the data we collect: if we don’t need it, we don’t ask for it."
                    }), "\n", _jsx(_components.li, {
                      children: "We limit the permissions our apps request on your devices."
                    }), "\n", _jsx(_components.li, {
                      children: "We put a lot of security measures into place including in-transit encryption, encryption\nat-rest, and requiring employees and contractors to sign non-disclosure agreements."
                    }), "\n", _jsxs(_components.li, {
                      children: ["When you email us at ", _jsx(_components.a, {
                        href: "mailto:privacy@modulabs.io",
                        children: "privacy@modulabs.io"
                      }), ", someone from our\nPrivacy Working Group will get back to you. You are always speaking with a human! No bots."]
                    }), "\n"]
                  }), _jsxs(_components.p, {
                    children: ["We do work with sub-processors. We've listed links to our current sub-processors at the end\nof this page. With each vendor, we assess their commitment to privacy and we sign a data\nprocessing addendum with them that include the controller-processor ", _jsx(_components.a, {
                      href: "https://ec.europa.eu/info/law/law-topic/data-protection/international-dimension-data-protection/standard-contractual-clauses-scc_en",
                      children: "Standard Contractual\nClauses"
                    }), "."]
                  }), _jsxs(_components.p, {
                    children: ["Last but not least, we know privacy regulations are constantly evolving. We root for\nstronger consumer privacy laws! Several Modulabs are members of the ", _jsx(_components.a, {
                      href: "http://iapp.org/",
                      children: "International Agency\nof Privacy Professionals"
                    }), " and use IAPP resources alongside legal counsel\nto stay aware of relevant changes in the regulatory landscape."]
                  }), _jsx(_components.h3, {
                    children: "Relevant US laws"
                  }), _jsx(_components.p, {
                    children: "The US does not have a national consumer privacy law akin to GDPR. We’d love to see one put\nin place and until then, shout out to California for leading with the California Consumer\nPrivacy Act (\"CCPA\" — more information following this GDPR section) and our spiritual home\nstate of Illinois for its Biometric Information Privacy Act."
                  }), _jsxs(_components.p, {
                    children: ["There are national US security laws that are relevant to GDPR. Chief amongst them are: the\n", _jsx(_components.a, {
                      href: "https://it.ojp.gov/PrivacyLiberty/authorities/statutes/1286",
                      children: "Foreign Intelligence Surveillance Act\n(FISA)"
                    }), " and Executive Order\n12-333. FISA establishes ways for US law enforcement and intelligence agencies to gather\ninformation within the US about non-US entities suspected of espionage or terrorism.\nExecutive Order 12-333 sets out how US intelligence agencies can gather information,\nincluding outside the borders of the US."]
                  }), _jsxs(_components.p, {
                    children: ["Virtually every American software service is subject to FISA. That includes all the American\nbig tech companies you can think of as well as any European service that uses cloud\ninfrastructure from Amazon Web Services, Microsoft Azure, or Google Cloud Computing. It also\nincludes small tech American companies like us, Modulabs LLC. However ", _jsx(_components.strong, {
                      children: "to date, Modulabs\nhas never been served a FISA order or National Security Letter."
                    })]
                  }), _jsx(_components.h2, {
                    children: "California Consumer Privacy Act (CCPA)"
                  }), _jsx(_components.p, {
                    children: "In the CCPA, there is an important distinction between what are referred to as “service\nproviders”, “businesses”, and “third parties”. You can see how the regulation defines these\nwords by visiting the California Attorney General’s website:\nhttps://www.oag.ca.gov/privacy/ccpa."
                  }), _jsxs(_components.p, {
                    children: [_jsx(_components.em, {
                      children: "Under the CCPA, Modulabs is a “service provider.”"
                    }), " That means when we process data you\nprovide, we do so solely for the purpose you signed up for. Our business model is simple: we\ncharge a recurring subscription fee to our customers. We do not sell personal information or\nuse your data for any other commercial purposes unless with your explicit permission."]
                  }), _jsx(_components.p, {
                    children: "The CCPA also grants residents of California with additional rights related to their\ninformation. We grant those rights to all of our customers and detail them in our Privacy\npolicy. Our Privacy policy also explains the information we collect in order to provide our\nservices and clearly lists the only times we access or share your data."
                  }), _jsx(_components.h2, {
                    children: "US Health Insurance Portability and Accountability Act (HIPAA)"
                  }), _jsxs(_components.p, {
                    children: ["Our products are currently ", _jsx(_components.em, {
                      children: "not"
                    }), "\n", _jsx(_components.a, {
                      href: "https://www.hhs.gov/hipaa/for-professionals/security/laws-regulations/index.html",
                      children: "HIPAA"
                    }), "-compliant\nand we do not have immediate plans to become so."]
                  }), _jsx(_components.h2, {
                    children: "Subprocessors"
                  }), _jsx(_components.p, {
                    children: "Modulabs uses third party subprocessors, such as cloud computing providers and customer\nsupport software, to provide our services. We enter into data processing agreements\nincluding GDPR Standard Contractual Clauses with each subprocessor, and require the same of\nthem."
                  }), _jsx(_components.p, {
                    children: "You can see which subprocessors we use by application by viewing the following linked lists:"
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsx(_components.li, {
                      children: _jsx(_components.a, {
                        href: "./subprocessors/modulabs-subprocessors",
                        children: "Modulabs subprocessors"
                      })
                    }), "\n"]
                  }), _jsxs(_components.p, {
                    children: ["We also use other software as a company that are not part of providing our services but may\ncollect your personal information for other purposes. You can view this list of processors\nin the following page: ", _jsx(_components.a, {
                      href: "./subprocessors/company-processors",
                      children: "Company processors"
                    })]
                  }), _jsxs(_components.p, {
                    children: ["Adapted from the ", _jsx(_components.a, {
                      href: "https://github.com/basecamp/policies",
                      children: "Basecamp open-source policies"
                    }), " / ", _jsx(_components.a, {
                      href: "https://creativecommons.org/licenses/by/4.0/",
                      children: "CC\nBY 4.0"
                    })]
                  })]
                })
              })
            })
          })
        })
      }), _jsx(Footer, {})]
    });
  }
}
export default MDXContent;
